export var isBrowser = "object" !== "undefined";
